<template>
    <div v-scrollspy="'.dpp-detail'" class="dpp-bar bar">
        <mvtShifter type="2">
            <a v-scroll href="#propertyDetailPanel" class="active">Details</a>
            <a v-scroll href="#openHousePanel" v-if="dpp.openHouses && dpp.openHouses.length > 0 && !dpp.isRentals">Open House</a>
            <a v-scroll href="#propertyDescriptionPanel" v-if="dpp.description">Description</a>
            <a v-scroll href="#keyInsightPanel" v-if="!dpp.hideKeyInsights && !dpp.isRentals" >Key Insights</a>
            <a v-scroll href="#locationPanel" v-if="dpp.geo.lat && dpp.geo.lng">Location</a>
            <a v-scroll href="#propertySchedulePanel" v-if="componentMounted && (!dpp.isActive || dpp.isRentals)">Schedule Tour</a>
            <a v-scroll href="#propertyNearbyHomePanel" v-if="dpp.isPrOnly && !dpp.isRentals">Nearby Homes</a>
            <a v-scroll href="#propertyMortgagePanel" v-if="componentMounted && !dpp.isRentals" >Payment</a>
            <a v-scroll href="#propertyEstimatePanel" v-if="!dpp.isRentals">Home Value</a>
            <a v-scroll href="#propertySaleProceedsPanel" v-if="!dpp.isActive && !dpp.isRentals">Sale Proceeds</a>
            <a v-scroll href="#propertyPriceHistoryPanel" v-if="getPriceHistory && getPriceHistory.length">History</a>
            <a v-scroll href="#propertyMarketPanel" v-if="dpp.marketTrendTable && !dpp.hideMarketStatistics && !dpp.isRentals">Statistics</a>
            <a v-scroll href="#propertyVeteransPanel" v-if="showVeteran && !dpp.isRentals">Veterans</a>
            <a v-scroll href="#dppInlineHotlead" v-if="componentMounted">Ask Question</a>
            <a v-scroll href="#nearbyAffordPanel" v-if="dpp.isRentals">Rent vs Buy</a>
            <a v-scroll href="#propertyNearbyHomePanel" v-if="!dpp.isPrOnly">Nearby Homes</a>
            <a v-scroll href="#faqPanel" v-if="dpp.faqs && !dpp.isRentals">FAQ</a>
            <a v-scroll href="#propertySeoPanel">Nearby Areas</a>
        </mvtShifter>
    </div>
</template>

<script src="./dpp-bar.js"></script>
